import { DSModal } from "@components/design-system/organisms/DSModal";
import React from "react";

import Patients from "../../patients/Patients";

export function PatientSelectForAction({
  selectedPatientUuid,
  setSelectedPatientName,
  setSelectedPatientUuid,
  modalTitle,
  modalText,
  confirmAction,
  additionalOptions,
  loading,
}) {
  return (
    <>
      <Patients
        isForPatientSelectionAction={true}
        setSelectedPatientUuid={setSelectedPatientUuid}
        setSelectedPatientName={setSelectedPatientName}
      />

      <DSModal
        isOpen={selectedPatientUuid !== ""}
        onClose={() => setSelectedPatientUuid("")}
        title={modalTitle}
        dataTestId="patient-select-action-modal"
        actions={[
          {
            label: "Whoops, wrong patient",
            variant: "cancel",
            onClick: () => setSelectedPatientUuid(""),
            dataTestId: "cancel-button",
          },
          {
            label: "Yes, purrfect pairing!",
            variant: "primary",
            onClick: confirmAction,
            disabled: loading,
            dataTestId: "confirm-button",
          },
        ]}
      >
        <h5>{modalText}</h5>
        {additionalOptions ? <div>{additionalOptions}</div> : null}
      </DSModal>
    </>
  );
}
